module.exports = __webpack_public_path__ + "img/103.0742b61c.jpg";